import React, { useState, useEffect } from 'react';
import { useAccount, useWriteContract, useReadContract } from 'wagmi';
import { abi } from './ERC20Abi'
import { PaymentMethod } from '../utils/Primitives';

interface AllowanceNeededProps {
  paymentMethod: PaymentMethod
  amount: bigint
  onAllowanceSet?: () => void
}

const AllowanceNeeded: React.FC<AllowanceNeededProps> = ({
  paymentMethod,
  amount,
  onAllowanceSet
}) => {
  const [needsAllowance, setNeedsAllowance] = useState(true);
  const { address } = useAccount();
  const {
    writeContract,
    status,
    isPending
  } = useWriteContract()

  const { data: currentAllowance } = useReadContract({
    address: paymentMethod.address as `0x${string}`,
    abi,
    functionName: 'allowance',
    args: [
      address as `0x${string}`,
      process.env.NEXT_PUBLIC_PAYMENT_METHODS_CONTRACT_ADDRESS as `0x${string}`
    ],
    query: {
      enabled: !!address
    }
  })

  useEffect(() => {
    console.log('Allowance check:', {
      currentAllowance,
      amount,
      needsAllowance: currentAllowance !== undefined ? currentAllowance < amount : true
    });

    if (currentAllowance !== undefined) {
      setNeedsAllowance(currentAllowance < amount);
    }
  }, [currentAllowance, amount]);

  useEffect(() => {
    console.log('Status change:', {
      status,
      needsAllowance
    });

    if (status === 'success') {
      setNeedsAllowance(false);
      onAllowanceSet?.();
    }
  }, [status, onAllowanceSet, needsAllowance])

  console.log('Render state:', {
    needsAllowance,
    currentAllowance,
    status,
    isPending
  });

  const handleSetAllowance = async () => {
    try {
      await writeContract({
        address: paymentMethod.address as `0x${string}`,
        abi,
        functionName: 'approve',
        args: [process.env.NEXT_PUBLIC_PAYMENT_METHODS_CONTRACT_ADDRESS as `0x${string}`, amount]
      })
    } catch (error) {
      console.error('Failed to approve:', error)
    }
  }

  if (!needsAllowance) {
    return <div>Allowance transaction sent.</div>;
  }

  return (
    <button
      onClick={handleSetAllowance}
      disabled={isPending}
      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
    >
      {isPending ? 'Approving...' : 'Set Allowance'}
    </button>
  );
}

export default AllowanceNeeded;